// @format
import React from 'react';
import Viewer from './Viewer';
import { Wrapper, Header, Home } from './ViewerTrust';

export default () => (
  <Wrapper>
    <Header
      style={{
        justifyContent: 'flex-end',
      }}
    >
      <Home />
    </Header>
    <Viewer />
  </Wrapper>
);
